import { groupBy } from 'lodash';
import moment from 'moment';

class OrderNotesController {
  transformTransactions () {
    return groupBy(this.order.transaction, (transaction) => {
      return transaction.created_at.substring(0, 10);
    });
  }

  getTransactions () {
    if (!this.transactions) {
      this.transactions = this.transformTransactions();
    }

    return this.transactions;
  }

  isErrorCode (code) {
    switch (code) {
    case null:
    case '200':
    case 'token':
    case 'attempt_payment':
    case 'adjustment':
    case 'refund':
    case 'integration_confirmed':
    case 'redeem_gifted_success':
      return false;
    }

    return true;
  }

  isTotalAdjustment (code) {
    switch (code) {
    case 'adjustment':
    case 'refund':
      return true;
    }

    return false;
  }

  formatTime (utcTime) {
    return moment(`${utcTime}+00:00`)
      .format('LLLL');
  }

  isManual (log) {
    return !!log.details && log.details.transaction_id === 'Manual Refund';
  }

  showTick(log) {
    return log.code === '200'
        || log.code === 'integration_confirmed'
        || log.code === 'redeem_gifted_success';
  }
}

OrderNotesController.$inject = [];

export default OrderNotesController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/order/controllers/order.notes.controller.js